import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

const state = {
  data: []
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/talent/index.js